import pkg from '../../package.json';

const PLAID_IN_FLIGHT_KEY = 'plaid_link_in_flight';

export const PLAID_RECOVERY_WINDOW_MS = 25 * 60 * 1000;

export interface PlaidInFlightMarker {
  linkSessionId: string | null;
  openedAt: number;
  appVersion: string;
  route: string;
}

export const writePlaidInFlightMarker = (linkSessionId: string | null): void => {
  const marker: PlaidInFlightMarker = {
    linkSessionId,
    openedAt: Date.now(),
    appVersion: pkg.version,
    route: `${window.location.pathname}${window.location.search}`,
  };
  localStorage.setItem(PLAID_IN_FLIGHT_KEY, JSON.stringify(marker));
};

export const clearPlaidInFlightMarker = (): void => {
  localStorage.removeItem(PLAID_IN_FLIGHT_KEY);
};

export const readPlaidInFlightMarker = (): PlaidInFlightMarker | null => {
  const raw = localStorage.getItem(PLAID_IN_FLIGHT_KEY);
  if (raw === null) return null;
  try {
    const parsed = JSON.parse(raw) as Partial<PlaidInFlightMarker>;
    if (
      typeof parsed.openedAt !== 'number' ||
      typeof parsed.appVersion !== 'string' ||
      typeof parsed.route !== 'string'
    ) {
      clearPlaidInFlightMarker();
      return null;
    }
    return {
      linkSessionId: typeof parsed.linkSessionId === 'string' ? parsed.linkSessionId : null,
      openedAt: parsed.openedAt,
      appVersion: parsed.appVersion,
      route: parsed.route,
    };
  } catch {
    clearPlaidInFlightMarker();
    return null;
  }
};

export const isPlaidMarkerRecoverable = (marker: PlaidInFlightMarker): boolean =>
  Date.now() - marker.openedAt < PLAID_RECOVERY_WINDOW_MS;

export const buildInterruptionProperties = (marker: PlaidInFlightMarker) => ({
  linkSessionId: marker.linkSessionId,
  msSinceLinkOpened: Date.now() - marker.openedAt,
  appVersionAtOpen: marker.appVersion,
  appVersionNow: pkg.version,
  liveUpdateApplied: marker.appVersion !== pkg.version,
});
